import '@babel/polyfill'
import './modules/gsap'
import GLightbox from 'glightbox'
import './modules/menu-scroll'
import './modules/swiper'
import './modules/contact-form'
import './modules/bse-widget'
import './modules/select-persons'
import './modules/post-glightbox'

import { lazyLoading } from './modules/lazyload'
import { pageLoad } from './modules/page-loader'
import { menuScroll } from './modules/menu-scroll'
import { hamburgerAnimate } from './modules/hamburger'
import { registerTabPanel } from './modules/tab-panel'
import { registerTermsSwitcher } from './modules/terms-switcher'
import { registerNestedMenu } from './modules/menu-nested'

hamburgerAnimate()
pageLoad()
registerTabPanel()
registerTermsSwitcher()
registerNestedMenu()

const lightbox = GLightbox({
  touchNavigation: true,
  loop: true,
  autoplayVideos: false,
})
